import { Card, Pagination, Table, ViewHeader, useGet } from '@enkla-gui'

import { icons } from '@config'

export default function Jobs({ id }) {
  const { data: jobs, loading, sorting, setSorting, setPage } = useGet({ endpoint: `api/company/${id}/jobs` })
  return (
    <Card
      title='Schemalagda jobb'
      icon={icons.job}
      loading={loading}
    >
      <Table
        rows={jobs?.data}
        link={`/#!/job/@{id}`}
        sorting={sorting}
        empty={{
          text: 'Inga schemalagda jobb har körts',
          icon: icons.cogs
        }}
        functions={{
          outcome: row => <span class={`badge w-100 bg-${row.successful_count === row.invoice_count ? 'success' : 'warning'}`}>{row.successful_count + " av " + row.invoice_count}</span>
        }}
        useSorting={sort => setSorting({ ...sort })}
        keys={['_this>function:outcome', 'job_type_label', 'created_at>date:full']}
        headers={[
          {
            value: 'Behandlades utan fel',
            class: 'min'
          },
          {
            key: 'job_type',
            value: 'Jobb',
            sortable: true
          },
          {
            key: 'createdAt',
            value: 'Utfört',
            sortable: true
          },
        ]}
      />
      <Pagination data={jobs} fetch={setPage} />
    </Card>
  )
}
